module.exports = __webpack_public_path__ + "static/media/rd_logo.7899991f.svg";